
    <span
      [class]="computedChipClasses()"
      (click)="handleClick()"
      [attr.tabindex]="clickable ? 0 : undefined"
      [attr.role]="clickable ? 'button' : undefined"
      (keydown)="handleKeyDown($event)"
    >
      <!-- Avatar/Icon -->
      @if (avatar || icon) {
      <div [class]="avatarContainerClasses()">
        @if (avatar) {
        <img [src]="avatar" [alt]="avatarAlt" [class]="avatarClasses()" />
        } @else if (icon) {
        <ui-icon [name]="icon" [size]="iconSize()" class="relative z-10"></ui-icon>
        }
      </div>
      }

      <!-- Label -->
      <span class="relative z-10 truncate">
        {{ label }}
        <ng-content></ng-content>
      </span>

      <!-- Delete button -->
      @if (deletable) {
      <button
        [class]="computedDeleteClasses()"
        (click)="handleDelete($event)"
        [attr.aria-label]="'Remove ' + label"
        type="button"
      >
        <ui-icon name="x" [size]="deleteIconSize()"></ui-icon>
      </button>
      }

      <!-- Glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full"
      >
        <div
          class="absolute inset-0 bg-linear-to-r from-transparent via-white/30 to-transparent
                    transform -skew-x-12 -translate-x-full hover:translate-x-full
                    transition-transform duration-1000 ease-out"
        ></div>
      </div>

      <!-- Premium floating particles -->
      @if (variant === 'premium') {
      <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-40 rounded-full">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/3 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
      </div>
      }
    </span>
  